import React from 'react';

export const ShimmerProdutos = () => {
  const list = [0, 1, 2, 3, 4, 5, 6, 7];
  return (
    <div style={{ textAlign: 'left', paddingTop: '10px' }}>
      <h4 className="title-category capitalize">
        <div className="shine shimmer-title" style={{ marginBottom: '0' }} />
      </h4>
      <div className="row">
        {list.map((index) => (
          <div key={index} className="col-md-6">
            <div className="shimmer-produto-card">
              <div>
                <div
                  style={{
                    right: '22px',
                    position: 'absolute',
                  }}
                >
                  <div className="shine shimmer-logo" style={{ marginTop: '0', height: '75px', width: '75px' }} />
                </div>
                <div className="item_descricao">
                  <div
                    className="shine shimmer-title"
                    style={{
                      margin: '0px',
                      height: '25px',
                      width: '120px',
                    }}
                  />
                  <div className="shine shimmer-line" style={{ width: 'calc(100% - 25px)' }} />
                  <div>
                    <div className="shine shimmer-line" style={{ width: '70px' }} />
                  </div>
                  {/* <div className="shine shimmer-line" style={{ width: '70px' }} /> */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
